
import { mapGetters } from 'vuex'
export default {
    name: 'CryptoWalletCard',
    props: {
        item: {
            type: [Array, Object],
            default: () => {},
        },
    },
    data() {
        return {
            bankButtonLoading: false,
        }
    },
    computed: {
        ...mapGetters({
            bankAccount: 'themes/player-bank/bankAccount',
        }),
    },
    methods: {
        getLimitedName(text) {
            if (!text) return '-'
            const displayLimit = 30
            if (text.length > displayLimit) {
                return text.substring(0, displayLimit) + '...'
            } else {
                return text
            }
        },
        async onDeleteWallet(id) {
            if (!window.confirm(`${this.tl('areYouSureToDelete')}?`))
                return null
            this.bankButtonLoading = true
            await this.$store.dispatch(
                'themes/player-bank/deletePlayerCryptoWallet',
                id
            )
            this.bankButtonLoading = false
        },
        async onSetPrimary(id) {
            this.bankButtonLoading = true
            const form = { is_primary: true }
            await this.$store.dispatch(
                'themes/player-bank/updatePlayerCryptoWallet',
                { ...form, id }
            )
            this.bankButtonLoading = false
        },
        // shortenString(str) {
        //     if (!str) return
        //     if (str?.length > 25) {
        //         return str.slice(0, 8) + '....' + str.slice(-8)
        //     }
        //     return str
        // },
    },
}
